export enum OrderDeliveryTypeEnum {
  delivery = 'delivery',
  pickup = 'pickup',
}
